import React, { useContext, useEffect, useRef, useState } from "react";
import { cotizadorCSS } from "./Cotizador.css";
import { CarDataForm } from "./Steps/Step1/CarDataForm";
import { ShowPrice } from "./Steps/Step2/ShowPrice";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { HeaderCotizador } from "./HeaderCotizador/HeaderCotizador";
import { BuroContainer } from "./Steps/Step3/BuroContainer";
import { scrollToElement } from "../Landing/functions";
import { ExitScreen } from "./Steps/Step2/ExitScreen/ExitScreen";
import { Congratulations } from "./Steps/step5/Congratulations";
import { useCarCalculator } from "../../Hooks/useCarCalculator";
import { Dialog } from "primereact/dialog";
import { ResponsiveDialogProvider } from "../../Context/ResponsiveDialogContext";
import UserDashboardView from "../User/dashboard/UserDashboardView";
import { AuthContext } from "../../Context/AuthContext";

function Cotizador({ submitEndpointOverride = null }) {
   const urlParams = useParams();
   const { secret, share, id } = urlParams;
   const location = useLocation();
   const navigate = useNavigate();
   const { authInfo } = useContext(AuthContext);

   const params = new URLSearchParams(location.search);
   const isShared = params.get('share') === 'true';
   const isSharedCode = params.get('share_code') === 'true';
   const isCotizador3 = submitEndpointOverride === 'cotizador3';

   const [stepNum, setStepNum] = useState(secret || isSharedCode || isShared ? 2 : 1);
   const [budgetUpdated, setBudgetUpdated] = useState(false);

   const internalVariables = useRef({
      secret: secret,
      budget_id: id
   });

   useEffect(() => {
      if (stepNum === 4) {
         navigate("/mi-dashboard");
      }
   }, [stepNum]);

   const {
      calculatorState,
      setState,
      loading,
      plazoVal,
      setPlazoVal,
      plazoTimer,
      errorsArray,
      canContinue,
      submit,
      loadInsurances,
      cleanErrors,
      setClass,
      sumAmountAndAccesories,
      handleAutoCompleteAddress,
      coloniesFiltered,
      dropdownRef,
      typeRegime,
      residualValue,
      stateAmple,
      percentageDownPayment,
      hadleResidualValue,
      type_coverage,
      handleStatePlateChange,
      showManualAddressFields,
   } = useCarCalculator(internalVariables, setStepNum, undefined, null, authInfo?.isAuth === true, null, null, submitEndpointOverride);


   useEffect(() => {
      scrollToElement("HeaderCotizador");
   }, []);

   useEffect(() => {
      if (stepNum === "exit") return;

      if (stepNum < 1) setStepNum(1);

      if (stepNum > 5) setStepNum(5);
   }, [stepNum]);


   return (
      <div css={cotizadorCSS()}>
         <HeaderCotizador actualStep={stepNum} />

         <section className="StepsContainer">
            {(stepNum === 1 || stepNum === 2) && (
               <CarDataForm
                  setStep={setStepNum}
                  internalVariables={internalVariables}
                  isShared={isShared}
                  isSharedCode={isSharedCode}
                  state={calculatorState}
                  setState={setState}
                  loading={loading}
                  plazoVal={plazoVal}
                  setPlazoVal={setPlazoVal}
                  plazoTimer={plazoTimer}
                  errorsArray={errorsArray}
                  canContinue={canContinue}
                  submit={submit}
                  loadInsurances={loadInsurances}
                  cleanErrors={cleanErrors}
                  setClass={setClass}
                  sumAmountAndAccesories={sumAmountAndAccesories}
                  typeRegime={typeRegime}
                  residualValue={residualValue}
                  stateAmple={stateAmple}
                  percentageDownPayment={percentageDownPayment}
                  hadleResidualValue={hadleResidualValue}
                  type_coverage={type_coverage}
                  handleStatePlateChange={handleStatePlateChange}
                  hideTypeCoverage={isCotizador3}
                  isCotizador3={isCotizador3}
                  secret={secret}
               />
            )}
            {stepNum === 2 && (


               < ShowPrice
                  state={calculatorState}
                  setState={setState}
                  setStep={setStepNum}
                  internalVariables={internalVariables}
                  isShared={isShared}
                  isSharedCode={isSharedCode}
                  onBudgetUpdated={() => setBudgetUpdated(true)}
                  budgetUpdated={budgetUpdated}
                  setBudgetUpdated={setBudgetUpdated}
                  setStepNum={setStepNum}
                  isCotizador3={isCotizador3}

               />

            )}
            {stepNum === "exit" && <ExitScreen />}
            {stepNum === 3 && <BuroContainer setStep={setStepNum} state={calculatorState} />}
            {/*  {stepNum === 4 &&
               <div className="section">
                  <UserDashboardView />
               </div>
            } */}
         </section>
      </div >
   );
}

export { Cotizador };
